export default {
    login:[],
    logout:[
        {
            icon:'mag-icon-nav-menu-home',
            href:'http://www.mag.travel/',
            name:'Главная',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-agencies',
            href:'http://www.mag.travel/for_agency/',
            name:'Агентствам',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-touroperators',
            href:'http://www.mag.travel/for_operators/',
            name:'Туроператорам',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-rates',
            href:'http://www.mag.travel/rates/',
            name:'Тарифы',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-partners',
            href:'http://www.mag.travel/partners/',
            name:'Партнеры',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-faq',
            href:'http://www.mag.travel/faq/',
            name:'FAQ',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-about',
            href:'http://www.mag.travel/about_company/',
            name:'О компании',
            spa: '',
            min: false,
        },
        {
            icon:'mag-icon-nav-menu-contacts',
            href:'http://www.mag.travel/contact/',
            name:'Контакты',
            spa: '',
            min: false,
        },
    ],
}